// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__ifG94","colMaxWidth":"Table_colMaxWidth__1I3tE"};